import type { FaireProductEntity } from "../../entity_types/product";

export const p_7i3loi4i8y: FaireProductEntity = {
  token: "p_7i3loi4i8y",
  type: "product",
  name: "Mexican Hot Chocolate Gift Set - Small",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/5f81205e6f597462a70662f3376188a8bce90333a5a3213ddd19288b76427c22.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ea7dfdad1a215e1a330bdcf55963f801c976fcef2bcc500ee7d58fd8390fb65b.jpeg",
    "https://cdn.faire.com/fastly/f49b39829d66f5f8f4100f0be1ae9fd19e4ace55324ee367103d4cc4b7ca5df2.jpeg",
    "https://cdn.faire.com/fastly/bb76fc6c41bdb20f44ff8b1375cbc72dfbc6ea46639ae94f9db91706304434a7.jpeg",
  ],
  priceDollars: 30,
  description:
    "To make authentic Mexican Hot Chocolate, you need traditionally made chocolate, a hand-carved molinillo, and the perfect ceramic mug to drink it out of. Luckily, we've put together this Mexican Hot Chocolate gift set with everything your customers will need for the perfect gift.\nCocoa is a key part of the Mexican gastronomy - it’s a legacy food made for sharing. By using everything in our Mexican Hot Chocolate Gift Set, your shoppers will get rich, complex-flavored, smooth hot chocolate drink that will retain the unique aroma and nostalgic taste enjoyed for generations.\n\nWhat's included: \n\nVilla Real Mexican Hot Chocolate with Almonds:\nSet of 2 Clay Mugs\nSmall Traditional Molinillo Whisk\n *Lead Free\n\nSize of gift box: 16 x 9 x 4''",
  tags: [],
  msrpDollars: 60,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:57.566Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
